'use client';

import {
	BigNum,
	MarketType,
	PRICE_PRECISION_EXP,
} from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useCallback } from 'react';
import { getLiveMarkPrice, useLiveMarkPrice } from 'src/stores/marketLiveState';

const DEFAULT_VALUE = BigNum.zero(PRICE_PRECISION_EXP);
const DEFAULT_MARKET_ID = new MarketId(0, MarketType.PERP);

/**
 * Mark/oracle prices now come from the market live-state module (all
 * transports arbitrated there); see ui/docs/market-live-state-migration.md.
 */
const useMarkPrice = (marketId: MarketId = DEFAULT_MARKET_ID): BigNum => {
	return useLiveMarkPrice(marketId) ?? DEFAULT_VALUE;
};

/**
 * Returns a function that gets the mark price for any market from the
 * market live-state module. Use this in list components where you can't
 * call useMarkPrice per-market.
 */
export const useGetMarkPriceForMarket = () => {
	return useCallback(
		(marketId: MarketId): BigNum => getLiveMarkPrice(marketId) ?? DEFAULT_VALUE,
		[]
	);
};

export default useMarkPrice;
